import { withStyles } from '@material-ui/core';

import FloorOption from './component';
import styles from './styles';

export default withStyles(styles)(FloorOption);
